"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _TableFooter = _interopRequireDefault(require("@material-ui/core/TableFooter"));
var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));
var _styles = require("@material-ui/core/styles");
var _utils = require("../utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultPaginationStyles = {
  root: {
    '&:last-child': {
      padding: '0px 24px 0px 24px'
    }
  },
  toolbar: {},
  selectRoot: {},
  '@media screen and (max-width: 400px)': {
    toolbar: {
      '& span:nth-child(2)': {
        display: 'none'
      }
    },
    selectRoot: {
      marginRight: '8px'
    }
  }
};
var TablePagination = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TablePagination, _react$default$Compon);
  function TablePagination() {
    var _this;
    _classCallCheck(this, TablePagination);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TablePagination).apply(this, arguments));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRowChange", function (event) {
      _this.props.changeRowsPerPage(event.target.value);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handlePageChange", function (_, page) {
      _this.props.changePage(page);
    });
    return _this;
  }
  _createClass(TablePagination, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        count = _this$props.count,
        classes = _this$props.classes,
        options = _this$props.options,
        rowsPerPage = _this$props.rowsPerPage,
        page = _this$props.page;
      var textLabels = options.textLabels.pagination;
      return /*#__PURE__*/_react.default.createElement(_TableFooter.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TablePagination.default, {
        className: classes.root,
        classes: {
          caption: classes.caption,
          toolbar: classes.toolbar,
          selectRoot: classes.selectRoot
        },
        count: count,
        rowsPerPage: rowsPerPage,
        page: (0, _utils.getPageValue)(count, rowsPerPage, page),
        labelRowsPerPage: textLabels.rowsPerPage,
        labelDisplayedRows: function labelDisplayedRows(_ref) {
          var from = _ref.from,
            to = _ref.to,
            count = _ref.count;
          return "".concat(from, "-").concat(to, " ").concat(textLabels.displayRows, " ").concat(count);
        },
        backIconButtonProps: {
          id: 'pagination-back',
          'data-testid': 'pagination-back',
          'aria-label': textLabels.previous
        },
        nextIconButtonProps: {
          id: 'pagination-next',
          'data-testid': 'pagination-next',
          'aria-label': textLabels.next
        },
        SelectProps: {
          id: 'pagination-input',
          SelectDisplayProps: {
            id: 'pagination-rows',
            'data-testid': 'pagination-rows'
          },
          MenuProps: {
            id: 'pagination-menu',
            'data-testid': 'pagination-menu',
            MenuListProps: {
              id: 'pagination-menu-list',
              'data-testid': 'pagination-menu-list'
            }
          }
        },
        rowsPerPageOptions: options.rowsPerPageOptions,
        onChangePage: this.handlePageChange,
        onChangeRowsPerPage: this.handleRowChange
      })));
    }
  }]);
  return TablePagination;
}(_react.default.Component);
_defineProperty(TablePagination, "propTypes", {
  /** Total number of table rows */
  count: _propTypes.default.number.isRequired,
  /** Options used to describe table */
  options: _propTypes.default.object.isRequired,
  /** Current page index */
  page: _propTypes.default.number.isRequired,
  /** Total number allowed of rows per page */
  rowsPerPage: _propTypes.default.number.isRequired,
  /** Callback to trigger rows per page change */
  changeRowsPerPage: _propTypes.default.func.isRequired
});
var _default = (0, _styles.withStyles)(defaultPaginationStyles, {
  name: 'MUIDataTablePagination'
})(TablePagination);
exports.default = _default;